/*
    Typing less, without taking anything away.

    On a deployment that serves one mail domain, making somebody type `@patronekrani.com` after
    their own name is asking them to repeat what the address bar already said. So the domain can
    be declared once, in the brand file, and shown as a fixed suffix.

    Declared, not guessed. The obvious shortcut — take the domain from the host — is wrong here
    and was measured to be wrong: a person signed in to info@patronekrani.com through
    webmail.raporekrani.com. Guessing would have sent them to a mailbox that does not exist, and
    the failure would have looked like a wrong password.

    So the suffix is a convenience and never a lock:

      typed "info"                     → info@patronekrani.com
      typed "info@patronekrani.com"    → unchanged, no second domain glued on
      typed "armagan@makrosum.com"     → unchanged, another domain still works

    The middle case is the one people actually hit: they paste or type the whole address out of
    habit, and an interface that answered info@patronekrani.com@patronekrani.com would be worse
    than the one that made them type it.
*/

/** The address to sign in with, from what was typed and what the deployment declared. */
export function fullAddress(typed: string, mailDomain: string | null): string {
    const value = typed.trim();
    if (!value) return '';
    // An @ means they have written an address, whatever else is true.
    if (value.includes('@')) return value;
    if (!mailDomain) return value;
    return `${value}@${mailDomain}`;
}

/**
 * Whether the fixed suffix belongs on screen.
 *
 * It disappears the moment an @ is typed, because from then on the field holds a whole address and
 * a suffix beside it would be describing something that is not going to happen.
 */
export function suffixVisible(typed: string, mailDomain: string | null): boolean {
    return Boolean(mailDomain) && !typed.includes('@');
}
